<template>
    <div class="food-v3-container">
        <!-- Stats Header Cards (sur le fond sombre, comme index.vue) -->
        <FoodStatsNavigation :stats="stats" activeTab="stock_movements" @click="goToTab" />

        <!-- Carte blanche -->
        <div class="ppv2-bg-white dark:ppv2-bg-dark ppv2-rounded-3xl ppv2-p-6">
            <StockMovementsPage api-base="/back-office/v3/food/stock-movements" :canEditNotes="canEditNotes" />
        </div>
    </div>
</template>

<script>
import FoodStatsNavigation from './FoodStatsNavigation.vue'
import StockMovementsPage from '../Stock/StockMovementsPage.vue'

export default {
    name: 'BoFoodV3StockMovements',
    components: { FoodStatsNavigation, StockMovementsPage },
    props: {
        establishment: {
            type: Object,
            default: () => ({}),
        },
        token: {
            type: String,
            default: '',
        },
        /** Permission « Modifier un produit » passée par Blade (`:can-edit-notes`) ; le serveur fait foi. */
        canEditNotes: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            stats: {
                products: 0,
                categories: 0,
                packs: 0,
                options: 0,
                tables: 0,
                table_categories: 0,
                tags: 0,
                stock_movements_today: 0,
            },
        }
    },
    methods: {
        goToTab(key) {
            const url = `/back-office/v3/food?tab=${encodeURIComponent(key)}`
            if (window.Turbo) {
                window.Turbo.visit(url)
            } else {
                window.location.href = url
            }
        },
        async fetchStats() {
            try {
                const response = await fetch('/api/v3/food/stats')
                const json = await response.json()
                if (json.success) {
                    this.stats = { ...this.stats, ...json.data }
                }
            } catch (error) {
                console.error('Stats error:', error)
            }
        },
    },
    mounted() {
        this.fetchStats()
        // Retire le fond blanc du conteneur parent, comme index.vue
        const mainContainer = document.getElementById('main-container')
        if (mainContainer) {
            mainContainer.classList.add('food-v3-no-bg')
        }
    },
    beforeDestroy() {
        const mainContainer = document.getElementById('main-container')
        if (mainContainer) {
            mainContainer.classList.remove('food-v3-no-bg')
        }
    },
}
</script>

<style scoped lang="scss">
.food-v3-container {
    padding: 0;
}
</style>

<!-- Non scopé : même override de fond que index.vue (la page peut être servie sans lui) -->
<style lang="scss">
#main-container.food-v3-no-bg {
    background: transparent !important;
    border-radius: 0px;
}

.dark #main-container.food-v3-no-bg {
    background: transparent !important;
}
</style>
